<!-- 行情列表组件 含表头 -->
<template>
  <div class="quotation-common-box">
    <!-- 表头 -->
    <div class="header">
      <div
        v-for="(item, index) in header"
        :key="`${item.key}-${index}`"
        :style="item.style"
        class="header-item">
        <div>{{item.name}}</div>
        <img v-if="item.showTip"
          src="https://j5.dfcfw.com/sc/image/202110/20211009012345.png"
          class="header-tip-icon"
          @click="() => item.showModal && item.showModal()"/>
      </div>
    </div>
    <!-- 顶部更多信息 -->
    <div>
      <slot name="top-extra"></slot>
    </div>
    <!-- 内容 -->
    <div class="list-box">
      <div v-for="(item, index) in dataList" :key="index">
        <slot name="list-item" :item="item"></slot>
      </div>
    </div>
    <slot name='list-bottom-extra'>

    </slot>
    <!-- 查看更多 -->
    <div v-if="!$isEmpty(moreText)"
      @click="clickMore"
      class="list-more">{{moreText}}</div>
    <!-- 提示弹窗 -->
    <legend-tip-modal
      :modal-type="modalType"
      :detail-info="detailInfo"
      @clickCancel="() => { modalType = '' }"
      @clickConfirm="confirmModal"
      />
  </div>
</template>

<script>
import LegendTipModal from '@/components/chart/LegendTipModal.vue';
import tool from '@/utils/tool';

export default {
  name: 'quotation-common-list',

  components: {
    LegendTipModal,
  },

  props: {
    listType: {
      type: String,
      default: '',
    },
    headerList: {
      type: Array,
      default: () => [],
    },
    dataSource: { // 表内数据
      type: Promise,
      default: null,
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
    moreText: {
      type: String,
      default: '',
    },
    clickTrack: {
      type: String,
      default: '',
    },
    moreLink: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dataList: [],
      modalType: '',
    };
  },

  computed: {
    header() {
      if (this.listType === 'annualizationOf7D' && !this.$isEmpty(this.dataList)) {
        const showTip = this.dataList.findIndex((item) => item.navType === 0) >= 0;
        console.log('===> showTip', showTip);
        return this.headerList.map((item) => (item.key === 'netAssetValue' ? {
          ...item,
          showTip,
          tipModalType: 'annualizationOf7D',
        } : item));
      }
      return this.headerList;
    },
  },

  watch: {
    dataSource: {
      handler() {
        this.dataSource.then((res) => {
          this.dataList = res || [];
        })
          .catch(() => { this.dataList = []; });
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    if (!this.$isEmpty(this.dataSource)) {
      this.dataSource.then((res) => { this.dataList = res || []; })
        .catch(() => { this.dataList = []; });
    }
  },

  methods: {

    clickMore() {
      this.$emit('clickMore');
      if (this.clickTrack) {
        window.sendTrackLog('Div', 'Click', this.clickTrack, '');
      }
      if (this.moreLink) {
        tool.goDetail(this.moreLink, this.$goFundApp);
      }
    },

    showTip(item) {
      this.modalType = this.$isEmpty(this.modalType) ? item.tipModalType : '';
    },

    confirmModal() {
      this.modalType = '';
      this.$goFundApp();
    },
  },
};
</script>

<style lang="less" scoped>
.quotation-common-box {
  margin-top: 24px;
  width: 100%;
  .header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 28px;
    color: #999999;
    line-height: 28px;
    margin-bottom: 16px;
    .header-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      .header-tip-icon {
        width: 28px;
        height: 28px;
        margin-left: 4px;
      }
    }
  }
  .list-more {
    line-height: 30px;
    font-size: 30px;
    color: #008AFF;
    text-align: center;
    padding: 32px 24px;
  }
}
</style>
